import React from 'react';
import GTMDataLayer from './gtm';

const FilterSpots = (props) => {

  const handleSpotsFilter = (e) => {
    if (e.target.value) {
      props.setFilters({...props.filters, spots: e.target.value, page: 0});
    }

    GTMDataLayer({
      event: 'customer_story_filter_spots',
      pageUrl: location.href,
      filter_spots: e.target.value
    });
  };

  return (
    <div className='filter-spots'>
      <h3>{Drupal.t('Charging Spots')}</h3>
      <div>
        <select onChange={handleSpotsFilter} defaultValue={props.selected} id="spots-filter">
          <option value='all'>{Drupal.t('All')}</option>
          <option value='less50'>&lt;50</option>
          <option value='50to100'>50-100</option>
          <option value='more100'>&gt;100</option>
        </select>
      </div>
    </div>
  );
};

export default FilterSpots;